import {getPreference} from '@netx/core-user-next/utils/getPreference';

export const assetExpirationEnabled = () =>
	getPreference('asset.expire.enabled', true);
